<template>
    <div id="asw-attribute-rule-table" class="asw-attribute-rule-table element-shadow">
        <div class="section-title">
            <h2>{{__( 'Attribute Condition', 'attribute-stock-woocommerce' )}}</h2>
            <div class="tap">
                <button type="button" id="add-group-rule" class="button"  @click="addGroup()">+ {{__( 'Add Group', 'attribute-stock-woocommerce')}}</button>
                <span class="woocommerce-help-tip" :title="__( 'Match groups are processed from top to bottom in order. Only the first successful match will be used, unless <strong>Match all groups</strong> is enabled. A product or variation must have all attributes in a group to match.', 'attribute-stock-woocommerce')"></span>
            </div>
            <button type="button" class="button all-toggle" @click="toogleAllSections()">{{toggleButtonText}}</button>
        </div>
        <div class="asw-table-wrap">
            <SlickList lockAxis="y" v-model="sets" :useDragHandle="true" helperClass="asw-dragging" id="tbl-asw-group" class="table-outer form-table element-shadow attribute-group-section">
                <SlickItem v-for="(saved_rule, index) in sets" :key="index" :index="index">
                    <td class="asw-group">
                        <div class="asw-group-header">
                            <div class="asw-title-group">
                                <!-- translators: %d is replaced with "number" which show group count -->                         
                                <span class="group-title">{{ sprintf( __('Group #%d:', 'attribute-stock-woocommerce'), index + 1) }}</span>
                                <button type="button" class="button add-attribute-rule" :class="{ disabled: saved_rule.rows.length >= attributesLength}" @click="addRow(index)">
                                    + {{__( 'Add Attribute', 'attribute-stock-woocommerce')}}
                                </button>
                                <span class="asw-selected-wrap">
                                    <span class="asw-selected-label" :class="'asw-label-'+label.type" v-for="label in getSelectedAttributesList(saved_rule)">
                                        <span class="name" v-if="label.name">{{ label.name }}</span>
                                        <span class="value">{{ label.value }}</span>
                                    </span>
                                </span>
                            </div>
                            <div class="asw-group-actions-wrap">
                                <div class="asw-group-quantity-multiplier">
                                    <label>{{__( 'Quantity multipliers', 'attribute-stock-woocommerce')}}</label>
                                    <input type="number" :name="getSetFieldName(index, 'multiplier')" step="any" min="0" :lang="locale" placeholder="1.00" v-model.number="saved_rule.multiplier" />
                                </div>
                                <div class="asw-group-actions">
                                    <button type="button" class="asw-action asw-toggle-group" title="Toggle" @click="saved_rule.open = !saved_rule.open">
                                        <i class="dashicons" :class="{ 'dashicons-arrow-up': saved_rule.open, 'dashicons-arrow-down': !saved_rule.open }"></i>
                                    </button>
                                    <button type="button" class="asw-action asw-move-group" title="Move" v-handle>
                                        <i class="dashicons dashicons-move"></i>
                                    </button>
                                    <button type="button" class="asw-action asw-duplicate-group" title="Duplicate" @click="duplicateGroup(index)">
                                        <i class="dashicons dashicons-admin-page"></i>
                                    </button>
                                    <button type="button" class="asw-action asw-delete-group" title="Delete" @click="removeGroup(index)">
                                        <i class="dashicons dashicons-dismiss"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <table class="table-outer form-table element-shadow attribute-rule-section" :class="{ open: saved_rule.open }">
                            <tr class="attribute-header">
                                <th>{{__( 'Attribute name', 'attribute-stock-woocommerce')}}</th>
                                <th>{{__( 'Term name', 'attribute-stock-woocommerce')}}</th>
                                <th>{{__( 'Action', 'attribute-stock-woocommerce')}}</th>
                            </tr>
                            <tr v-for="(row, rowIndex) in saved_rule.rows" :key="rowIndex">
                                <td>
                                    <select :name="getRowFieldName(index, rowIndex, 'attribute')" v-model.number="row.attribute" @change="row.term = 0">
                                        <option value="">{{__( 'Select attribute', 'attribute-stock-woocommerce')}}</option>
                                        <option v-for="(options) in attributeOptions" :key="options.value" :value="options.value" :disabled="isAttributeSelected(options.value, index, rowIndex)">
                                            {{ options.label }}
                                        </option>
                                    </select>
                                </td>
                                <td>
                                    <select :name="getRowFieldName(index, rowIndex, 'term')" v-if="row.attribute" v-model.number="row.term">
                                        <!-- translators: %s is replaced with "string" which show selected attribute name -->  
                                        <option value="0">{{ sprintf( __('Any %s', 'attribute-stock-woocommerce'), getAttributeLabel(row.attribute)) }}</option>
                                        <option v-for="(options) in getTerms(row.attribute)" :key="options[1]" :value="options[0]">
                                            {{ options[1] }}
                                        </option>
                                    </select>
                                    <select v-show="!row.attribute" disabled>
                                        <option value="0">{{__( 'Select term', 'attribute-stock-woocommerce')}}</option>
                                    </select>
                                </td>
                                <td>
                                    <button type="button" class="asw-action delete-attribute-rule" title="Delete" :class="{disabled:(saved_rule.rows.length === 1 && !row.attribute)}" @click="removeRow(index, rowIndex)">
                                        <i class="dashicons dashicons-trash"></i>
                                    </button>
                                </td>   
                            </tr>
                        </table>
                    </td>
                </SlickItem>
            </SlickList>
        </div>
    </div>
</template>

<script>
    
    import { SlickList, SlickItem, HandleDirective } from './sorting';
    const { __, sprintf } = wp.i18n;
    export default {
        name: 'AttributeMatcher',
        props: {
            name: {
                type: String,
                default: 'asw_attributes'
            }
        },
        components: {
            SlickList,
            SlickItem
        },
        directives: { 
            handle: HandleDirective 
        },
        data() {
            return {
                locale: conditional_vars.locale,
                sets: [],
            };
        },
        created() {
            //Get attribute details from global localise variable
            this.attributes = conditional_vars.attributes;
            this.attributesLength = Object.keys(this.attributes).length;

            // set initial match sets data
            const sets = conditional_vars.saved_rules;
            if (sets.length) {
                //If we found saved rule then we will ad them in sets variable
                if (sets.length === 1) {
                    sets[0].open = true;
                } else {
                    for (let set of sets) {
                        set.open = false;
                    }
                }
                this.sets = sets;
            } else {
                //If we have not found any saved rule then we will add blank rule
                this.addGroup();
            }

            const attributeOptions = [];
            const termLabels = {};
            for (const id in this.attributes) {
                //If not found any attribute then skip it.
                if( !this.attributes.hasOwnProperty(id)) {
                    continue;
                }
                const attr = this.attributes[id];
                //For alphabatic order sort for attribute
                attributeOptions.push({
                    value: id,
                    label: attr.label
                });
                //Prepare term lable array
                for( const term in attr.terms ){
                    //check attribute index exist or not
                    if( this.attributes.hasOwnProperty(id) ){
                        termLabels[attr.terms[term][0]] = attr.terms[term][1];
                    }
                }
            }
            this.attributeOptions = attributeOptions.sort((a, b) => a.label.localeCompare(b.label));
            this.termLabels = termLabels;
        },
        methods:{
            __,
            sprintf,
            addGroup() {
                const length = this.sets.push({
                    open: true,
                    multiplier: '',
                    rows:[]
                });
                this.addRow(length - 1);
            },
            addRow(setIndex) {
                const set = this.sets[setIndex];
                if( !set.open ) { 
                    set.open = true;
                }
                if( set.rows.length >= this.attributesLength){
                    return;
                }
                const row = {
                    attribute: '',
                    term: 0
                }
                set.rows.push(row);
            },
            removeRow(setIndex, rowIndex){
                this.sets[setIndex].rows.splice(rowIndex, 1);
                if (!this.sets[setIndex].rows.length) {
                    this.addRow(setIndex);
                }
            },
            getSetFieldName(setIndex, name) {
                return `${this.name}[${setIndex}][${name}]`;
            },
            getRowFieldName(setIndex, rowIndex, name) {
                return `${this.name}[${setIndex}][rows][${rowIndex}][${name}]`;
            },
            getSelectedAttributes(setIndex, excludeRowIndex) {
                const selected = [];
                const rows = this.sets[setIndex].rows;
                for (let i = 0; i < rows.length; i++) {
                    if (i !== excludeRowIndex && rows[i].attribute) {
                        selected.push(+rows[i].attribute);
                    }
                }
                return selected;
            },
            isAttributeSelected(attributeId, setIndex, excludeRowIndex){
                return this.getSelectedAttributes(setIndex, excludeRowIndex).indexOf(+attributeId) !== -1;
            },
            getAttributeLabel(attributeId){
                return this.attributes[attributeId].label;
            },
            getTermLabel(termId){
                return this.termLabels[termId];
            },
            getTerms(attribute) {
                return this.attributes[attribute].terms;
            },
            removeGroup(groupId){
                //check first that group cantain any attribute rule or note
                if( this.isAttributeThere(groupId)){
                    const confirmation = this.__( 'Do you really want to remove this attribute match group?', 'attribute-stock-woocommerce');
                    if (!confirm(confirmation)) return;
                }
                this.sets.splice(groupId, 1);
                if(!this.sets.length){
                    this.addGroup();
                }
            },
            duplicateGroup(groupId){
                const copy = JSON.parse(JSON.stringify(this.sets[groupId]));
                copy.open = true;
                this.sets.splice(groupId+1, 0, copy);
            },
            isAttributeThere(groupId){
                const currentGroup = this.sets[groupId];
                //Check for multiple attrobute rules
                if( currentGroup.rows.length !== 1 ){
                    return true;
                }
                //Check for only one attrobute rule with non-NULL value
                if( currentGroup.rows[0].attribute !== '' ) {
                    return true;
                }

                return false;
            },
            getSelectedAttributesList(saved_rule){
                const labels = [];
                const selected_attrs = saved_rule.rows.filter(row => row.attribute && row.term >= 0);
                //If term and attribute selected then it will add to labels array
                for ( let row of selected_attrs ){
                    labels.push({
                        type: 'attribute',
                        name: this.getAttributeLabel(row.attribute),
                        value: +row.term ? this.getTermLabel(row.term) : this.__( 'Any', 'attribute-stock-woocommerce'),
                    })
                }
                //If term and attrbutes not selected then it will add placeholder in label array
                if( !labels.length ){
                    labels.push({
                        type: 'attribute',
                        value: '...'
                    });
                }
                return labels;
            },
            isAllOpen() {
                for (let set of this.sets) {
                    if (!set.open) return false;
                }
                return true;
            },
            toogleAllSections(){
                if( this.isAllOpen()){
                    for (let set of this.sets) {
                        set.open = false;
                    }
                } else {
                    for (let set of this.sets) {
                        if (!set.open) set.open = true;
                    }
                }
            },
            initTooltips() {
                jQuery('.asw-attribute-rule-table .woocommerce-help-tip').tipTip({
                    fadeIn: 50,
                    fadeOut: 50,
                    delay: 200
                });
            }
        },
        mounted() {
            this.$nextTick(this.initTooltips);
        },
        updated() {
            this.$nextTick(this.initTooltips);
        },
        computed: {
            toggleButtonText() {
                if (this.isAllOpen()) {
                    return this.__( 'Collapse all', 'attribute-stock-woocommerce');
                } else {
                    return this.__( 'Expand all', 'attribute-stock-woocommerce');
                }
            }
        },
    };
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/AttributeMatcher.vue